import React, { PureComponent } from "react";
import { valueConverter } from "../../util-functions/util-funtions";
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  LabelList,
} from "recharts";
import DATA from "../../assets/data";
import {
  barGraphConstruct,
  barGraphConstructHalfVolume,
} from "../../util-functions/util-funtions";

const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props;

  return (
    <g>
      <text
        x={x + 8}
        y={y}
        dy={-4}
        fill={stroke}
        fontSize={8}
        textAnchor="middle"
      >
        {valueConverter(value)}
      </text>
    </g>
  );
};
export default class QuarterAnalysisBarChart extends PureComponent {
  constructor() {
    super();
    this.state = {
      toggleData: [],
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.length !== 0) {
      let res =
        props.data.length > 0
          ? props.dataKey === "QuaterVolume"
            ? barGraphConstruct(props.data)
            : props.dataKey === "HalfVolume"
            ? barGraphConstructHalfVolume(props.data)
            : []
          : [];
      state.resultSet = res[0];
      if (state.toggleData.length === 0) state.toggleData = res[1];
    }
    return state;
  }

  toggleKey = (indx) => {
    let { toggleData } = this.state;
    toggleData[indx].flag = !toggleData[indx].flag;
    this.setState({ toggleData });
  };

  renderTooltip(e, data) {
    return data.map((itm, ind) => {
      return (
        <div
          key={ind}
          style={{
            height: "30px",
            width: "auto",
            paddingLeft: "10px",
            paddingRight: "10px",
            backgroundColor: "white",
          }}
        >
          <span style={{ color: DATA.COLOR[ind] }}>
            {valueConverter(itm[`${Object.keys(itm)[0]}`][`${e.label}`])}
          </span>
        </div>
      );
    });
  }

  render() {
    let { resultSet, toggleData } = this.state;
    return (
      <>
        <ResponsiveContainer height="70%" width="102%">
          <BarChart
            width={550}
            height={180}
            data={this.props.data ? resultSet : DATA.data}
            // barCategoryGap={-40}
            // barGap={this.props.type == 'SD'?-45:-40}
            barGap={10}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            {/* <CartesianGrid opacity={0.5} vertical={false} /> */}
            <YAxis
              style={{ fontSize: "12px" }}
              tickLine={false}
              padding={{ top: 35 }}
              tickFormatter={(tick) => {
                return valueConverter(tick);
              }}
            />
            <XAxis
              dataKey="name"
              style={{ fontSize: "12px" }}
              tickLine={false}
              tickFormatter={(tick) => {
                return tick.toUpperCase();
              }}
            />
            <Tooltip content={(e) => this.renderTooltip(e, this.props.data)} />
            {this.props.data.length > 0 ? (
              this.props.data.map((itm, ind) => {
                return (
                  <Bar
                  key={ind}
                    dataKey={`${
                      toggleData.length > 0 && toggleData[ind].flag
                        ? toggleData[ind].name
                        : ""
                    }`}
                    fill={DATA.COLOR[ind]}
                    barSize={18}
                  >
                    <LabelList
                      content={
                        <CustomizedLabel
                          myProps={this.props.data ? this.props.data : []}
                        />
                      }
                      position="insideTop"
                    />
                  </Bar>
                );
              })
            ) : (
              <Bar dataKey="2018" fill="#9f633d" />
            )}
          </BarChart>
        </ResponsiveContainer>
        {this.props.data.length > 0 ? (
          <ul
            style={{
              display: "flex",
              listStyle: "none",
              margin: "0px",
              marginBottom: "10px",
            }}
          >
            {toggleData.map((itm, ind) => {
              return (
                <li
                key={ind}
                  className="SS-ES-li"
                  onClick={() => this.toggleKey(ind)}
                  style={
                    itm.flag
                      ? { textDecoration: "", color: DATA.COLOR[ind] }
                      : {
                          textDecoration: "line-through",
                          color: DATA.COLOR[ind],
                        }
                  }
                >
                  <div
                    style={{
                      width: 4,
                      height: 4,
                      border: "solid",
                      float: "left",
                      margin: "5px",
                      backgroundColor: DATA.COLOR[ind],
                    }}
                  ></div>
                  {itm.name}
                </li>
              );
            })}
          </ul>
        ) : (
          ""
        )}
      </>
    );
  }
}
